<mat-card>
  <mat-card-content>
    <app-terms-display
      [termsLabel]="'Terms'"
      [header]="'PAD terms'"
      [message]="'You have a CAD bank account linked to your TUIO account'"
      [agreeLabel]="'I agree to the pre-authorize debit terms above'"
      [contentWidgetTag]="ContentWidgetTag.PadTermsCdn"
      [effectiveDateSetting]="Setting.PadTermsCdnDate"
      (submitted)="submit()">
    </app-terms-display>
  </mat-card-content>
</mat-card>